import { CarryStructureTile, ViewDetails } from './CarryStructureTile';

export interface CarryStructureFundCard {
  fund_id: string;
  name: string;
  display_name: string | null;
  coc_number: string | null;
  summary: string;
  to?: string;
}

function FundCard({ fund }: { fund: CarryStructureFundCard }) {
  return (
    <CarryStructureTile
      to={fund.to}
      className="flex flex-col justify-center rounded-lg border border-blue-200 bg-blue-50 px-4 py-4 dark:border-blue-900 dark:bg-blue-950/30"
      hoverClassName="hover:bg-blue-100 dark:hover:bg-blue-950/50"
    >
      <p className="text-sm font-semibold text-blue-800 dark:text-blue-300">
        {fund.display_name ?? fund.name}
      </p>
      <p className="mt-1 text-xs tabular-nums text-muted-foreground">
        CoC {fund.coc_number ?? '—'}
      </p>
      <p className="mt-2 text-xs text-muted-foreground">{fund.summary}</p>
      {fund.to && (
        <ViewDetails className="mt-2 text-xs font-medium text-blue-800 dark:text-blue-300" />
      )}
    </CarryStructureTile>
  );
}

export function CarryStructureFundCards({
  funds,
}: {
  funds: CarryStructureFundCard[];
}) {
  return (
    <div className="grid grid-cols-[repeat(auto-fit,minmax(190px,1fr))] gap-3">
      {funds.map((fund) => (
        <FundCard key={fund.fund_id} fund={fund} />
      ))}
    </div>
  );
}
